import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import Tabs from './ShopListTabs';
import EnabledShops from '../containers/EnabledShops';
import DisabledShops from '../containers/DisabledShops';

const ShopList = () => (
  <div>
    <Tabs>
      <div label={t('admin:shops.shop_list.tabs.enabled')}>
        <EnabledShops />
      </div>
      <div label={t('admin:shops.shop_list.tabs.disabled')}>
        <DisabledShops />
      </div>
    </Tabs>
  </div>
  );

export default ShopList;
